import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'

import adminStyles from './styles/admin.scss'

const GridContainer = props => {
  return (
    <div className={adminStyles.container}>
      <Grid>
        <Row>
          <Col md={12}>{props.children}</Col>
        </Row>
      </Grid>
    </div>
  )
}

export default GridContainer



// WEBPACK FOOTER //
// ./src/components/GridContainer.js